import { Map } from 'immutable'
import { WithTranslation } from 'react-i18next'

export interface IDeleteUserModalProps extends WithTranslation {
  user: Map<string, any>
  onRequestClose: () => {}
  deleteOrganizationUserBulk: ({
    userIds,
    from,
    isUpdateUsers,
  }: {
    userIds: number[]
    from: EnumDeleteUserFrom
    isUpdateUsers?: boolean
  }) => any
  reviewers: any[]
}

export interface IDeleteUserModalWithTextProps extends IDeleteUserModalProps {
  text: string
  handleDeleteOrganizationUserBulk: (from: EnumDeleteUserFrom) => any
  isUserFromMicroAction: boolean
  isUserFromReviews: boolean
  isUserFromMST: boolean
}

export enum EnumDeleteUserFrom {
  both = 'BOTH',
  microactions = 'MICROACTIONS',
  reviews = 'REVIEWS',
}
